import { jsx as _jsx } from "react/jsx-runtime";
import { LiteralBase, getLiteralBaseProps, baseEditableOptions } from "./TextLiteral";
import { useFormattedParts } from "./NumberLiteral";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { removeNegativeZero } from "../../utils";
export const CurrencyLiteral = ({ 
//field,
emptyEqualsZero, formatString, ...rest }) => {
    const { suffix: suffixValue = undefined, prefix: prefixValue = undefined } = rest;
    const { prefix = prefixValue, str, suffix = suffixValue } = useFormattedParts(removeNegativeZero(rest.field.value), {
        format: "currency_input"
    }, emptyEqualsZero, formatString);
    return (_jsx(LiteralBase, { ...getLiteralBaseProps(rest), prefix: prefix, suffix: suffix, children: str }));
};
export const EditorCurrencyLiterals = identityRecordOfFieldEditorOptions({
    CurrencyLiteral: {
        editableOptions: {
            ...baseEditableOptions,
            prefix: true,
            suffix: true
        }
    }
});
//# sourceMappingURL=CurrencyLiteral.js.map